/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProjectSettingsServiceDeskEmailType from '@jira/spa-apps__project-settings-service-desk-email/src/ExportedDefault.tsx';
import { HelpCenterSettingsRedirect } from '@jira/servicedesk__customer-service-common/src/HelpCenterSettingsRedirect.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type {
	Location,
	Query,
	Route,
	Match,
	HistoryAction,
} from '@atlassian/react-resource-router';

export const LazyProjectSettingsServiceDeskEmail: LazyComponent<{
	(props: {
		location: Location;
		query: Query;
		route: Route;
		match: Match;
		action: HistoryAction;
	}): React.JSX.Element;
	displayName: string;
}> = lazyForPaint<typeof ProjectSettingsServiceDeskEmailType>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-service-desk-email", jiraSpaEntry: "async-project-settings-service-desk-email" */ '@jira/spa-apps__project-settings-service-desk-email/src/ExportedDefault.tsx'
		),
);

const AsyncProjectSettingsServiceDeskEmail = (): React.JSX.Element => (
	<HelpCenterSettingsRedirect page="email">
		<LazyPage
			Page={LazyProjectSettingsServiceDeskEmail}
			pageId="project-settings-email"
			shouldShowSpinner
		/>
	</HelpCenterSettingsRedirect>
);

export default AsyncProjectSettingsServiceDeskEmail;
